import type {Logger} from './logger';

export default class ConsoleLogger implements Logger {
  constructor() {}
  logError(err: unknown): void {
    console.error(err);
  }

  logInfo(info: string): void {
    // Allow console.log here for the logger class, as this is an intentional logging utility.
    // eslint-disable-next-line no-console
    console.log(info);
  }
}
